import React from 'react';
import Descriptions from 'antd/es/descriptions';
import { Button, FormControl, InputGroup } from 'react-bootstrap';
import { AuthenticatedContextType } from '../../context/AuthenticatedContext';
import {
  dataDispWidth,
  userContentStyle,
  userLabelStyle,
} from '../../css/style';

interface DataProps {
  userdata: AuthenticatedContextType;
  searchTerm: string;
  changeSearchTerm: (event: {
    target: { value: React.SetStateAction<string> };
  }) => void;
  handleSearchClick: () => void;
}

const DataDisp: React.FC<DataProps> = ({
  userdata,
  searchTerm,
  changeSearchTerm,
  handleSearchClick,
}) => {
  const customerName = userdata.loginCustomer?.customerName ?? '';
  const corporateCode = userdata.loginCustomer?.corporateCode ?? '';

  return (
    <div style={{ width: dataDispWidth.userInfo }}>
      {/* ユーザ情報 */}
      <Descriptions
        bordered
        column={1}
        labelStyle={userLabelStyle}
        contentStyle={userContentStyle}
        style={{ marginBottom: '10px' }}
      >
        <Descriptions.Item label="ユーザ名" span={1}>
          {`${corporateCode} ◇ ${customerName}`}
        </Descriptions.Item>
      </Descriptions>
      <Descriptions
        bordered
        column={1}
        labelStyle={userLabelStyle}
        contentStyle={userContentStyle}
        style={{ marginBottom: '10px' }}
      >
        <Descriptions.Item label="事業所名" span={1}>
          <InputGroup>
            <FormControl
              placeholder="事業所名を入力"
              aria-label="事業所名"
              onChange={changeSearchTerm}
              onKeyPress={(event: { key: string }) => {
                if (event.key === 'Enter') {
                  handleSearchClick();
                }
              }}
              value={searchTerm}
              maxLength={100}
            />
            <InputGroup.Append>
              <Button variant="outline-secondary" onClick={handleSearchClick}>
                検索
              </Button>
            </InputGroup.Append>
          </InputGroup>
        </Descriptions.Item>
      </Descriptions>
    </div>
  );
};

export default DataDisp;
